<template>
  <div class="drc-view-container">
    <div class="drc-item-list-header">
      <div class="drc-item-list-header-column left">
        <span>{{t("papers.tabsDrc.DrcView.administratifActions")}}</span>
      </div>
      <div class="drc-item-list-header-column right">
        <span>{{t("papers.tabsDrc.DrcView.myActions")}}</span>
      </div>
    </div>
    <div class="drc-item-list">
      <div v-if="loading">
        <lottie-player src="/static/animations/animation-load-comments.json" background="transparent" speed="1"
                       style="width: 200px; height: 200px;margin: 0 auto" loop autoplay></lottie-player>
      </div>
      <div v-if="!loading && drcInfos.actions.length>0" v-for="info in drcInfos.actions" class="drc-item"
           :class="getSide(info)">
        <div class="drc-item-icon">
          <font-awesome-icon :icon="getIcon(info)"></font-awesome-icon>
        </div>
        <h4>{{ info.type_action.libelle }}</h4>
        <span class="action-date">{{ convertDate(info.dh, null, false) }}</span>
        <p v-if="info.titre !== null && info.titre.length>0">
          {{ info.titre }}
        </p>
        <div class="drc-item-with-doc" v-if="containsDocument(info)">
          <a target="_blank" @click="downloadDocument(info.iddrc_action)">
            <font-awesome-icon icon="paperclip"></font-awesome-icon>
            <span v-if="downloadingFileId !== info.iddrc_action">{{t("papers.tabsDrc.DrcView.myActions")}}</span>
            <span v-if="downloadingFileId === info.iddrc_action">{{t("papers.tabsDrc.DrcView.downloadDocument")}}</span>
          </a>
        </div>
      </div>
      <div v-if="!loading && drcInfos.actions.length===0" class="drc-item-empty">
        {{t("papers.tabsDrc.DrcView.noActionSaved")}}
      </div>
    </div>
    <div class="drc-item-send-comment">
      <div v-if="!commentSent" class="drc-item-send-comment-content">
        <textarea rows="3" v-model="comment" :maxlength="maxCommentLength"></textarea>
        <div class="drc-item-send-comment-char-counter" v-html="commentCharAvailable"></div>
      </div>
      <div v-if="commentSent" class="drc-item-send-comment-content">
        <lottie-player src="/static/animations/animation-send-email.json" background="transparent" speed="1"
                       style="width: 75px; height: 75px;margin: 0 auto" loop autoplay></lottie-player>
      </div>
      <div class="drc-item-send-comment-action">
        <div @click="submitComment()" :class="[this.canSubmit ? '' : 'disabled']"
             class="button primary mobile-block pull-right">
          {{t("papers.tabsDrc.DrcView.downloadDocument")}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import moment from "moment";
import API from '@s/API'
import axios from "axios";

export default {
  name: "DrcViewer",
  computed: {
    ...mapGetters({
      drcInfos: 'Papers/drcInfos',
    }),
  },
  beforeCreate() {

  },
  data() {
    return {
      loading: true,
      commentSent: false,
      comment: null,
      canSubmit: false,
      downloadingFileId: 0,
      maxCommentLength: 120,
      commentCharAvailable: "120 caractères restants"
    }
  },
  methods: {
    ...mapActions({
      getDrcInfos: 'Papers/getDrcInfos',
      putDrcComment: 'Papers/putDrcComment',
      setDrcInfos: 'Papers/setDrcInfos'
    }),
    viewDocumentUrl(action) {
      return API.apiBaseURL + API.route(API.endpoints.interlocutor.viewDrcDocument, {
        iddrc: this.props.drc.iddrc,
        idAction: action.iddrc_action
      });
    },
    downloadDocument(iddrc_action) {
      if (document.getElementById("link_" + iddrc_action)) {
        var fileLink = document.getElementById("link_" + iddrc_action);
        fileLink.click();
        return;
      }
      let that = this;
      this.downloadingFileId = iddrc_action;
      axios({
        url: API.route(API.endpoints.interlocutor.viewDrcDocument, {
          iddrc: this.props.drc.iddrc,
          idAction: iddrc_action
        }),
        method: 'GET',
        responseType: 'blob',
      })
        .then(response => {
          that.downloadingFileId = 0;
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.id = "link_" + iddrc_action;
          fileLink.style.display = 'none';
          fileLink.href = fileURL;
          fileLink.setAttribute('download', 'file.pdf');
          document.body.appendChild(fileLink);

          fileLink.click();
        })
        .catch(error => {
          console.log(error.response)
        });;
    },
    containsDocument(action) {
      return Number(action.doc) === 1;
    },
    submitComment: function () {
      this.commentSent = true;
      this.canSubmit = false;
      let that = this;
      this.putDrcComment({iddrc: this.props.drc.iddrc, title: this.comment}).then(() => {
        that.comment = '';
        that.commentSent = false;
        this.canSubmit = true;
        that.refreshList();
      });
    },
    convertDate(date, fromnow) {
      moment.locale(this.getLang());
      if (fromnow) {
        return moment(date).fromNow();
      }
      return (new Date(date)).toLocaleString();
    },
    getLang: function () {
      if (navigator.languages !== undefined)
        return navigator.languages[0];
      else
        return navigator.language;
    },
    getSide(item) {
      if (item.type_action.source === 'Client') {
        return 'right';
      }
      return "left";
    }
    ,
    getIcon(item) {
      return item.type_action.icone;
    },
    refreshList() {
      let that = this;
      console.log(this.props.drc);
      console.log(this.props.drc.iddrc);
      this.getDrcInfos({iddrc: this.props.drc.iddrc}).then(() => {
        that.loading = false;
      });
    }
  },
  props: {
    props: {
      type: Object
    }
  },
  watch: {
    comment(newVal, oldVal) {
      if (newVal.length > this.maxCommentLength) {
        newVal = newVal.substr(0, this.maxCommentLength);
      }
      let l = this.maxCommentLength - newVal.length;
      if (l > 1) {
        this.commentCharAvailable = l + " caractères restants";
      } else {
        this.commentCharAvailable = l + " caractère restant";
      }
      this.canSubmit = newVal.length > 0;
    }
  },
  mounted: function () {
    this.setDrcInfos([]);
    this.refreshList()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/drc/DrcViewer.vue